import EnumDataSource from "../utils/enum-data-source.util";

export const PATIENT_TYPE = "Patient";
export const PHYSICIAN_TYPE = "ReferringPhysician";

const objectTypes = {
  [PATIENT_TYPE]: "Patients",
  [PHYSICIAN_TYPE]: "Physician",
};

export const REFERRAL_SOURCE_OBJECT_TYPES = new EnumDataSource(objectTypes);
